import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {API_URL} from '../constants';

@Injectable({
    providedIn: 'root'
})
export class PaymentApiService {

    private apiUrl = `${API_URL}payment`;

    constructor(private http: HttpClient) {
    }

    /** Create Stripe Checkout Session */
    createCheckoutSession(body: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/create-checkout-session`, body);
    }

    /** Create Stripe Checkout Session */
    createBizCheckoutSession(body: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/create-biz-checkout-session`, body);
    }

    /** Create Stripe Checkout Session */
    createEventCheckoutSession(body: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/create-event-checkout-session`, body);
    }

    /**
     * Asks the server to re-check a Checkout Session with Stripe and returns its verdict
     * ({paid, status, purpose, eventId, amount, currency, reference}). The browser never decides that a payment succeeded.
     */
    syncSession(sessionId: string): Observable<PaymentOutcome> {
        return this.http.post<PaymentOutcome>(`${this.apiUrl}/sessions/${encodeURIComponent(sessionId)}/sync`, {});
    }

    /** Tells the server the payer pressed Cancel on Stripe's page (best effort; a later payment still counts). */
    cancelSession(sessionId: string): Observable<PaymentOutcome> {
        return this.http.post<PaymentOutcome>(`${this.apiUrl}/sessions/${encodeURIComponent(sessionId)}/cancel`, {});
    }
}

export interface PaymentOutcome {
    status: string;          // CREATED | PROCESSING | PAID | EXPIRED | FAILED | CANCELLED | PARTIALLY_REFUNDED | REFUNDED | DISPUTED
    paid: boolean;
    purpose?: string;        // MEMBERSHIP | EVENT_LOCAL | EVENT_BOOKING | BIZ_CONFERENCE
    eventId?: string;
    amount?: number;         // cents
    currency?: string;
    reference?: string;      // ledger id, quoted in confirmation emails
}
